import React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

interface Props {
  audienceButtonAnchorEl: HTMLElement | null;
  onCloseCallback: () => void;
  onAddGroupCallback: () => void;
  onSelectFromGroupCallback: () => void;
  groupName: string;
  targetAudience?: string;
  // Whether the group may be added whole. Adding a group is the default, so a
  // caller with no opinion keeps today's menu.
  canAddGroup?: boolean;
}

const defaultProps = {
  targetAudience: '',
  canAddGroup: true
};

export default function AudienceMenu(props: Props): React.ReactElement {
  const {
    audienceButtonAnchorEl,
    onCloseCallback,
    onAddGroupCallback,
    onSelectFromGroupCallback,
    groupName,
    targetAudience = defaultProps.targetAudience,
    canAddGroup = defaultProps.canAddGroup
  } = props;

  return (
    <Menu
      anchorEl={audienceButtonAnchorEl}
      open={Boolean(audienceButtonAnchorEl)}
      onClose={onCloseCallback}
      MenuListProps={{
        'aria-label': 'Actions'
      }}
    >
      {canAddGroup && (
        <MenuItem onClick={onAddGroupCallback}>
          {`Add ${groupName}`}
        </MenuItem>
      )}
      <MenuItem onClick={onSelectFromGroupCallback}>
        {`Select ${targetAudience} from ${groupName}`}
      </MenuItem>
    </Menu>
  );
}
